<template>
  <div >

      <b-row v-if="!isValid">
        <b-alert variant="danger" show>{{$ml.get("nosignup")}}</b-alert>
      </b-row>
      <div v-if="isValid">
        <b-row class="justify-content-center" style="text-align: center">
            <b-col cols="auto">
                <h3>{{$ml.get("simpleWelcome")}} {{username}} </h3>
                <h6>{{$ml.get("createpassword")}}</h6>
            </b-col>
        </b-row>
        <b-row class="justify-content-center marginaltop">
            <b-col lg="6" md="8" sm="10">
                <b-form @submit.prevent="submitForm">
                    <b-form-group label="Email:" label-for="email-input">
                        <b-form-input id="email-input" v-model="email" required placeholder="Email"></b-form-input>
                    </b-form-group>

                    <b-form-group label="Password:" label-for="password-input">
                        <b-input-group>
                            <b-form-input
                            id="password-input"
                            v-model="password"
                            :state="passwordState"
                            :type="passwordType"
                            :maxlength="passwordMaxLength"
                            required
                            placeholder="Password"
                            ></b-form-input>
                            <b-input-group-append>
                                <b-button
                                tabindex="-1"
                                v-if="passwordType === 'password'"
                                variant="db-sb1"
                                @click="passwordType = 'text'"
                                ><font-awesome-icon
                                    :icon="['fas', 'eye']"
                                ></font-awesome-icon
                                ></b-button>
                                <b-button
                                tabindex="-1"
                                v-if="passwordType === 'text'"
                                variant="db-sb1"
                                @click="passwordType = 'password'"
                                ><font-awesome-icon
                                    :icon="['fas', 'eye-slash']"
                                ></font-awesome-icon
                                ></b-button>
                            </b-input-group-append>
                            <b-form-invalid-feedback>
                                Passwords must contain at least: 7 characters, one lower
                                letter, one upper letter, one digit and one special character
                            </b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group v-if="password.length > 0" label="Confirm password:" label-for="password-confirm-input">
                        <b-input-group>
                            <b-form-input
                            id="password-confirm-input"
                            v-model="passwordConfirm"
                            :state="validatePassword"
                            :type="passwordType"
                            :maxlength="passwordMaxLength"
                            required
                            placeholder="Confirm password"
                            ></b-form-input>
                            <b-input-group-append>
                                <b-button
                                tabindex="-1"
                                v-if="passwordType === 'password'"
                                variant="db-sb1"
                                @click="passwordType = 'text'"
                                ><font-awesome-icon
                                    :icon="['fas', 'eye']"
                                ></font-awesome-icon
                                ></b-button>
                                <b-button
                                tabindex="-1"
                                v-if="passwordType === 'text'"
                                variant="db-sb1"
                                @click="passwordType = 'password'"
                                ><font-awesome-icon
                                    :icon="['fas', 'eye-slash']"
                                ></font-awesome-icon
                                ></b-button>
                            </b-input-group-append>
                            <b-form-invalid-feedback>
                                Passwords mismatch
                            </b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                    <b-row class="justify-content-center">
                        <b-col cols="auto">
                            <b-button type="submit" variant="primary">{{$ml.get('submitButton')}}</b-button>
                        </b-col>
                    </b-row>
                </b-form>
                <hr>
                <b-form @submit.prevent="urlSignupGithub"> 
                    <b-row class="justify-content-center">
                        <b-col cols="auto">
                            <b-button variant="oauth" type="submit"><font-awesome-icon :icon="['fab', 'github']" /> {{$ml.get("signupgithub")}}</b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </b-col>
        </b-row>
      </div>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import SigninService from '@/services/signin'
let signinService = new SigninService();
export default {
  name: 'signup',
  data: function() {
    return {
        signupid: "",
        isValid: true,
        username: "",
        email: "",
        password: "",
        passwordConfirm: "",
        passwordMaxLength: 30,
        passwordType: "password",
    }
  },
  computed: {
    passwordState() {
        let count = 0
        if (this.password.length >= 7) {
            if (this.password.match(/.*[0-9].*/)) count++;

            if (this.password.match(/.*[a-z].*/)) count++;

            if (this.password.match(/.*[A-Z].*/)) count++;

            if (this.password.match(/.*[!@#\$%\^\&*\)\(+=._-].*/)) count++;
        }
        return (count === 4) || (this.password === "")
    },
    validatePassword() {
        return this.password === this.passwordConfirm;
    },
  },
  mounted() {
    this.signupid = this.$route.params.signupid;
    this.getSignupInfos();
  },
  methods: {
    getSignupInfos() {
        signinService.signUp(this.signupid).then(user => {
            this.username = user.username;
            if (user.email) {
                this.email = user.email;
            }
        }).catch(err => {
            this.isValid = false;
        })
    },
    validateEmail(email) {
      const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    
    submitForm() {
        if (!this.passwordState) {
            alert("Invalid password.")
            return;
        }
        if (!this.validatePassword) {
            alert("Passwords mismatch.")
            return;
        }
        if (!this.validateEmail(this.email)) {
            alert("Invalid email. Please use a valid email.")
            return;
        }
        signinService.postSignupUser(this.signupid, {password: this.password, email: this.email})
        .then((response) => {
            EventBus.$emit("AuthChanged")
            this.$router.push("/");
        }).catch(err => {
            console.log(err);
        })
    },
    submitGithub() {
        signinService.postSignupGithub(this.signupid)
        .then(response => {
            console.log(response)
        }).catch(err => {
            console.log(err);
        })
    },
    urlSignupGithub() {
        window.location.href = signinService.urlSignupGithub(this.signupid);
    }
  }

}
</script>